<script>
export default {
  methods: {
    formatUrl(url) {
      if(!url.startsWith("http")) {
        url = "https://"+url
      }
      return url
    }
  }
}
</script>
